var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Button } from '../button';
import { Cross } from '../icon';
import { closeButtonStaticStyle } from './styles';
const sizeMap = {
    large: {
        buttonSize: 'medium',
        iconSize: 'small',
    },
    medium: {
        buttonSize: 'small',
        iconSize: 'xsmall',
    },
};
function CloseButton(_a) {
    var { 'aria-label': ariaLabel = 'Close', size = 'medium' } = _a, restProps = __rest(_a, ['aria-label', "size"]);
    return (_jsx(Button, Object.assign({ "aria-label": ariaLabel, css: closeButtonStaticStyle, icon: _jsx(Cross, { size: sizeMap[size].iconSize }), size: sizeMap[size].buttonSize, variant: "plain" }, restProps)));
}
export default CloseButton;
